import React from "react";

/**
 * Reserved 56×56 slot for the future chatbot FAB.
 *
 * Owned by `dashboard-redesign` (Requirement 13). The `help-docs-panel`
 * spec portals its `ChatbotFAB` button into this slot via
 * `document.getElementById("chatbot-launcher-slot")` — until then the
 * div stays empty, invisible (no border, no background), and
 * non-interactive.
 *
 * The position/dimensions here are the canonical Reserved_Slot contract
 * shared with `help-docs-panel/design.md`. Do not change them without
 * updating the `help-docs-panel` spec in the same edit
 * (Requirement 13.4).
 */
export function ChatbotLauncherSlot(): JSX.Element {
  return (
    <div
      id="chatbot-launcher-slot"
      data-testid="chatbot-launcher-slot"
      style={{
        position: "fixed",
        bottom: 24,
        right: 24,
        width: 56,
        height: 56,
        zIndex: 40,
      }}
    />
  );
}
